module.exports = __webpack_public_path__ + "img/decline.dca6e61a.svg";